import { useEffect, useState } from "react";
import Translated from "../feature/Translated";
import Card from "react-bootstrap/Card";
import { IoMail } from "react-icons/io5";
import Button from "react-bootstrap/Button";
import ContactForm from "../feature/ContactForm";
import DataPrivacyNote from "../feature/DataPrivacyNote";
import { useUserData } from "../../context/UserDataContext";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import {
  CONTACT_CATEGORIES,
  getSelectableCategories,
  isFieldPrefillable,
} from "../../data/contactCategories";

const SELECTABLE_CATEGORIES = getSelectableCategories();

const ContactPage = () => {
  const { token } = useUserData();
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const query = queryString.parse(location.search);

  // Pre-select the category from ?category=<key>, falling back to general for
  // missing or unknown values.
  const requestedCategory = query.category;
  const initialCategory = SELECTABLE_CATEGORIES.includes(requestedCategory)? requestedCategory : "general";
  const [selectedCategory, setSelectedCategory] = useState(initialCategory);
  const categoryConfig = CONTACT_CATEGORIES[selectedCategory];

  // Build pre-filled values from the remaining query params, whitelisting known
  // field names and excluding checkbox fields.
  const initialValues = Object.keys(query).reduce((acc, key) => {
    if (isFieldPrefillable(key) && typeof query[key] === "string") {
      acc[key] = query[key];
    }
    return acc;
  }, {});

  useEffect(() => {
    setSubmitted(false);
  }, [location.search]);

  useEffect(() => {
    setSelectedCategory(initialCategory);
  }, [initialCategory]);

  const handleCategoryChange = (nextCategory) => {
    setSelectedCategory(nextCategory);
    navigate(
      nextCategory === "general"
        ? "/contact"
        : `/contact?category=${nextCategory}`
    );
  };

  const renderForm = () => {
    const header = (
      <div className="centered">
        <Translated translationKey={categoryConfig.headingKey} />
      </div>
    );

    const trial = !token && (
      <div className="semi-dark-inner-box large-top-margin">
        <div>
          <Translated translationKey="contact_description" />
        </div>
        <Button
          className="medium-top-margin"
          aria-label="Request trial"
          role="button"
          onClick={() => navigate("/trial")}
        >
          <Translated translationKey="trial_request" />
        </Button>
      </div>
    );

    return (
      <div id="contact-page" className="contact-wrapper fade-in">
        <Card className="contact-panel" header={header}>
          <Card.Body>
            <ContactForm
              selectedCategory={selectedCategory}
              onCategoryChange={handleCategoryChange}
              selectableCategories={SELECTABLE_CATEGORIES}
              initialValues={initialValues}
              onSubmitted={() => setSubmitted(true)}
            />
          </Card.Body>
        </Card>
        {trial}
      </div>
    );
  };

  const renderSubmittedMessage = () => {
    return (
      <div id="contact-submitted" className="contact-wrapper fade-in">
        <Card className="blue-box">
          <h3 className="centered">
            <IoMail />
            &nbsp;&nbsp;
            <Translated translationKey="message_sent" />
          </h3>
          <Button
            aria-label="ok"
            role="button"
            onClick={() => setSubmitted(false)}
          >
            <Translated translationKey="ok" />
          </Button>
        </Card>
      </div>
    );
  };

  let content;
  if (submitted) {
    content = renderSubmittedMessage();
  } else {
    content = renderForm();
  }

  return (
    <div className="page-container max-width-container">
      <h1 className="centered">
        <Translated translationKey={categoryConfig.headingKey} />
      </h1>
      <div className="centered">
        <Translated translationKey={categoryConfig.infoKey} />
      </div>
      <div className="front-center-wrapper medium-top-margin">{content}</div>
      <DataPrivacyNote className="semi-dark-inner-box centered" />
    </div>
  );
};

export default ContactPage;
